module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Globe-6424a3a15271e2f19dfaa652a2b18639.svg";